import PRIMARY from "./primary";
import WIDGETS from "./widgets";

const ELEMENTS = {
    ...PRIMARY,
    ...WIDGETS,
};

export { PRIMARY, WIDGETS, ELEMENTS };
